// @flow

import { datadogRum } from '@datadog/browser-rum';

function init() {
  if (!window.Datadog) {
    console.info('Skipping Datadog Rum setup: window.Datadog is not set.');
  } else {
    datadogRum.init({
      applicationId: window.Datadog.RumConfig.applicationId,
      clientToken: window.Datadog.RumConfig.clientToken,
    });

    datadogRum.setRumGlobalContext(window.Datadog.rumGlobalContext);
  }
}

init();
